<template>
  <div v-if="notFound" :class="componentClassName">
    <a-page-heading>メール送信先設定</a-page-heading>

    <m-section>
      <m-action-card id="settingsSendchoiceListTitle" title="契約者選択">
        <m-data-table :fit="true" :data="[{}]" :show-header="false" :class="'m-checkbox'">
          <a-data-table-column align="center" :min-width="1">
            <template #default="">
              <a-checkbox
                id="checkAllCbx"
                v-model="suspendedCheckallModal"
                label="."
                style="color: white"
                :disabled="isSuspensionDisabled"
                @click="handleClickCheckall"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column align="right">
            <span class="m-user-selection-table__header-status-count">{{ chkCount }}</span
            >人選択中 / {{ companyList.length }}人
          </a-data-table-column>
        </m-data-table>
        <m-data-table ref="dataTable" empty-text="登録がありません" :fit="true" :data="filterdCompanyList">
          <a-data-table-column prop="selection" :min-width="30" :filterable="true" label="&nbsp;" align="left">
            <template #default="scope">
              <a-checkbox
                v-model="selectCheckbox[scope.row.id]"
                style="margin-top: -9px"
                @change="handleClickCheckbox(scope.row.id)"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column prop="companyID" :filterable="true" label="契約ID" align="left">
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_companyID"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('companyID', 'asc')"
                :handle-sort-descending="() => handleSort('companyID', 'desc')"
              />
            </template>
            <template #default="scope">
              {{ scope.row.companyID }}
            </template>
          </a-data-table-column>
          <a-data-table-column
            class="t-setting-sendchoice-list__wrap"
            prop="companyName"
            :filterable="true"
            :min-width="150"
            label="契約企業名"
            align="left"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_companyName"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('companyName', 'asc')"
                :handle-sort-descending="() => handleSort('companyName', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            class="t-setting-sendchoice-list__wrap"
            prop="adminName"
            :filterable="true"
            :min-width="150"
            label="マスタ管理者名"
            align="left"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_adminName"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('adminName', 'asc')"
                :handle-sort-descending="() => handleSort('adminName', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column
            class="t-setting-sendchoice-list__wrap"
            prop="adminEmail"
            :filterable="true"
            :min-width="150"
            label="メールアドレス"
            align="left"
          >
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_adminEmail"
                variant="sort-normal"
                :handle-sort-ascending="() => handleSort('adminEmail', 'asc')"
                :handle-sort-descending="() => handleSort('adminEmail', 'desc')"
              />
            </template>
          </a-data-table-column>
          <a-data-table-column prop="startDate" :filterable="true" :min-width="100" label="開通日" align="left">
            <template #filter="scope">
              <m-filter-dialog
                v-if="scope"
                id="filter_startDate"
                variant="sort-time"
                :handle-sort-ascending="() => handleSort('startDate', 'asc')"
                :handle-sort-descending="() => handleSort('startDate', 'desc')"
              />
            </template>
          </a-data-table-column>
        </m-data-table>
      </m-action-card>
    </m-section>
    <m-form-action-buttons>
      <template v-if="!readOnly">
        <a-button id="store" variant="block" color="primary" :disabled="chkCount === 0" @click="handleSendEdit"
          >保存</a-button
        >
      </template>
      <a-button id="cancel" variant="outlined" color="primary" @click="handleCancel">キャンセル</a-button>
    </m-form-action-buttons>
  </div>

  <!-- Confirm, Error Modal -->
  <teleport to="body">
    <o-modal
      id="resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button variant="block" color="primary" label="OK" size="small" @click="handleCloseModal" />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import AText from '@/components/atoms/text';
import MSection from '@/components/molecules/section';
import MDataTable from '@/components/molecules/data-table';
import ADataTableColumn from '@/components/atoms/data-table-column';
import OModal from '@/components/organisms/modal';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import { POINT } from '@/libs/constants';

export default {
  name: 't-setting-sendchoice-list',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    AText,
    MDataTable,
    ADataTableColumn,
    OModal,
  },
  mixins: [messageContent, customRequest, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
    authInfo: {
      type: String,
      default: '',
    },
    modelValue: {
      type: Array,
      default: new Array(0),
    },
  },
  emits: ['update:modelValue', 'change'],
  data() {
    return {
      selectedCompanyID: '',
      companyList: [],
      filterdCompanyList: [],
      resultModalVisible: false,
      resultModalTitle: '',
      resultModalContent: '',
      notFound: false,
      readOnly: false,
      selectCheckbox: {},
      chkCount: 0,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-sendchoice-list');
      return `${baseClassName} ${this.class}`.trim();
    },
    suspendedCheckall() {
      for (const id in this.selectCheckbox) {
        if (!this.selectCheckbox[id]) return false;
      }
      return true;
    },
  },
  watch: {
    selectCheckbox: {
      handler: function () {
        this.suspendedCheckallModal = this.suspendedCheckall;
      },
      deep: true,
    },
  },
  created() {
    if (this.companyID !== POINT) {
      this.$router.push({ path: '/permission-denied' });
    }

    if (this.authInfo === 'soOperator') {
      this.$router.push({ path: '/permission-denied' });
    }

    this.handlerFetchCompanyData();
  },
  methods: {
    handlerFetchCompanyData: function () {
      this.companyList = [];
      this.postRequest('/companymgmt/getinitdata')
        .then(e => {
          this.notFound = true;

          // voicedxOnlyFlag --> false、contractStatus --> 'use' のものだけを送信対象にする
          for (const tCompany of e.data) {
            if (
              !tCompany.companyID.match(/^tri/) &&
              tCompany.voicedxOnlyFlag === false &&
              tCompany.contractStatus === 'use'
            ) {
              this.companyList.push(tCompany);
              this.filterdCompanyList.push(tCompany);
            }
          }

          const sendMailList = ',' + this.$route.params.sendMailList;

          for (let i = 0; i < this.companyList.length; i++) {
            this.companyList[i].adminName = this.companyList[i].adminName
              ? this.companyList[i].adminName.replace('_', ' ')
              : this.companyList[i].adminName;
            this.companyList[i].id = i;
            this.filterdCompanyList[i].id = i;
            this.selectCheckbox[i] =
              sendMailList.indexOf(',' + this.companyList[i].companyID + ',') >= 0 ? true : false; // チェックボックスを選択状態にするかどうか

            if (this.selectCheckbox[i]) {
              this.chkCount++;
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('メール送信先設定'));
        });
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    // ソート時の処理
    handleSort(prop, dir) {
      const order = dir === 'asc' ? -1 : 1;
      this.filterdCompanyList.sort(function (a, b) {
        if (typeof a[prop] === 'undefined') return order;
        if (typeof b[prop] === 'undefined') return -order;
        if (a[prop] < b[prop]) return order;
        if (a[prop] > b[prop]) return -order;
        return 0;
      });
    },
    // 全選択・全解除処理
    handleClickCheckall() {
      const val = !this.suspendedCheckall;
      for (const id in this.selectCheckbox) {
        this.selectCheckbox[id] = val;
      }
      if (val) {
        this.chkCount = this.companyList.length;
      } else {
        this.chkCount = 0;
      }
    },
    handleClickCheckbox(id) {
      this.suspendConfimingID = id;

      // 選択人数を更新
      this.chkCount = 0;
      for (let i = 0; i < this.companyList.length; i++) {
        if (this.selectCheckbox[i]) {
          this.chkCount++;
        }
      }
    },
    handleSendEdit() {
      let sendMailList = '';
      for (let i = 0; i < this.companyList.length; i++) {
        if (this.selectCheckbox[i]) {
          sendMailList = sendMailList + this.companyList[i].companyID + ',';
        }
      }

      this.$router.push({
        name: 'SendMailEdit',
        params: {
          sendMailList: sendMailList,
          sendSubject: this.$route.params.sendSubject,
          sendMailBody: this.$route.params.sendMailBody,
        },
      });
    },
    handleCancel() {
      this.$router.push({
        name: 'SendMailEdit',
        params: {
          sendMailList: this.$route.params.sendMailList,
          sendSubject: this.$route.params.sendSubject,
          sendMailBody: this.$route.params.sendMailBody,
        },
      });
    },
  },
};
</script>
